import styled from 'styled-components';
import { Localize } from '@agilepoint/wat-react';
import { FlexBox, Typography } from '@agilepoint/wat-react-ux';


export const CopyRightInfo = styled(Typography.XSmall)`
    color : ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.secondaryTextColor};
`;

export function CopyRight(props: { year?: number }) {
    const { year } = props;
    return (
        <FlexBox justifyContent="center" alignItems="center" height='30px'>
            <CopyRightInfo><Localize translate='modules.defaultAppSettings.companyDetails.copyrightPrefixText' /> {year || ''} <Localize translate='modules.defaultAppSettings.companyDetails.copyrightSuffixText' /></CopyRightInfo>
        </FlexBox>
    );
}

